
import http from "./httpService";
// import  apiUrl  from ".././config.json";
const apiUrl = require("../config.json").apiUrl;

export const getbookReceiptData = (data) => {
    const apiEndPoint = `${apiUrl}/CommonAPIMethod`;
    return http.post(`${apiEndPoint}`,data);
  };